import Joi from "joi";
import { CONTENT_TYPES, SECTION_TYPES, SOURCE_PAGE_TYPES } from "../constants";

export const videoPlayed = Joi.object({
  sourceName: Joi.string().required(),
  sourcePage: Joi.string().required(),
  sourcePageType: Joi.string()
    .valid(...Object.values(SOURCE_PAGE_TYPES))
    .required(),
  sourceElement: Joi.string()
    .valid(...Object.values(SECTION_TYPES))
    .required(),
  contentType: Joi.string()
    .valid(...Object.values(CONTENT_TYPES))
    .required(),
  id: Joi.string().required(),
  title: Joi.string().required(),
  autoPlayed: Joi.boolean().required(),
  brainBreakSessionId: Joi.number().required(),
});

export const activityDownloaded = Joi.object({
  sourcePage: Joi.string().required(),
  sourcePageType: Joi.string()
    .valid(...Object.values(SOURCE_PAGE_TYPES))
    .required(),
  contentType: Joi.string()
    .valid(...Object.values(CONTENT_TYPES))
    .required(),
  id: Joi.string().required(),
  title: Joi.string().required(),
});

export const shared = Joi.object({
  sourcePage: Joi.string().required(),
  sourcePageType: Joi.string()
    .valid(...Object.values(SOURCE_PAGE_TYPES))
    .required(),
  contentType: Joi.string()
    .valid(...Object.values(CONTENT_TYPES))
    .required(),
  id: Joi.string().required(),
  title: Joi.string().required(),
});
